exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".el-radio-group[data-v-8345fb12]{display:flex;flex-direction:row;align-items:center;gap:16px}.el-radio[data-v-8345fb12]{margin-left:0;margin-right:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-8345fb12&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/UniversityManage/EquipmentManage/FirmwareManage/FirmwareManage.vue
// module id = 598
// module chunks = 0